import { useNavigate } from "react-router-dom";
import { navigation_constants } from "../../constants/navigation.constants";
import { FaAngleRight } from "react-icons/fa6";


const DeleteAccountInfoPage = () => {
    const navigate = useNavigate()

    const ArrowElement = () => <FaAngleRight style={{alignSelf: "center", paddingTop: 5}} color="black" size={16} />
    const BoldText = ({text}:{text:string}) => <b style={{color:"black"}}>{text}</b>

    
    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            textAlign: "center",
            transform: "translateY(-10%)", // Lifts the content up slightly
            // maxWidth: "600px", // Maximum width
            // margin: "0 auto", // Ensures the div stays centered horizontally
            marginLeft: "30px",
            marginRight: "30px"
            }}>
            <h1 style={{ fontWeight: "bold" }}>Account Deletion Steps</h1>
            <div style={{height: "10px"}} />
            <ul style={{ textAlign: "left" }}>
                <li style={{color: "grey"}}>Login to our app. Use a version downloaded from the playstore for better security</li>
                <li style={{color: "grey"}}>
                    Go to <BoldText text="profile" /> <ArrowElement /> <BoldText text="profile options" /> <ArrowElement /> <BoldText text="settings" /> <ArrowElement /> <BoldText text="account" /> <ArrowElement /> <BoldText text="delete account" />
                </li>
                <li style={{color: "grey"}}>Enter your password and click on delete account</li>
                <li style={{color: "grey"}}>All your data will be wiped off our servers after deletion</li>
            </ul>
            <div style={{height: "10px"}} />
            <button onClick={()=> navigate(navigation_constants.pages.home)} className="primary-button">Continue</button>
        </div>
    );
}

export default DeleteAccountInfoPage